import React from 'react';

const TextField = ({
  input,
  label,
  type,
  placeholder,
  disabled,
  multiline,
  meta: { touched, error, warning }
}) => {
  let hasStatus = null;
  let message = null;

  // remove touched from first two tests to
  // force form validation on initial load
  if (touched && error) {
    hasStatus = 'danger';
    message = error;
  } else if (touched && warning) {
    hasStatus = 'warning';
    message = warning;
  } else if (touched) {
    hasStatus = 'success';
    message = null;
  } else {
    hasStatus = null;
    message = null;
  }

  return (
    <div className={`form-group ${hasStatus ? 'has-' + hasStatus : ''}`}>
      <label className="pr-0" htmlFor={input.name}>
        {label}
      </label>
      {multiline ? (
        <textarea
          id={input.name}
          className="form-control form-control-danger form-control-warning form-control-success"
          {...input}
          rows={4}
        />
      ) : (
        <input
          id={input.name}
          className="form-control form-control-danger form-control-warning form-control-success"
          {...input}
          disabled={disabled}
          placeholder={placeholder}
          type={type}
        />
      )}
      {message ? <div className="form-control-feedback"> {message} </div> : ''}
    </div>
  );
};

export default TextField;



// WEBPACK FOOTER //
// ./src/pages/teacher/Settings/Profile/GeneralInformation/TextField/index.js